const CONSENT_COUNTRIES = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
  "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
  "SI", "ES", "SE", "IS", "LI", "NO", "GB", "CH", "CA",
]);

export type ConsentRegion = { country: string | null; required: boolean };

export function parseConsentRegion(trace: string, hostname: string): ConsentRegion {
  const host = trace.match(/^h=(.+)$/m)?.[1]?.trim().toLowerCase();
  const country = trace.match(/^loc=([A-Z0-9]{2})$/m)?.[1] ?? null;
  if (host !== hostname.toLowerCase() || !country || country === "XX" || country === "T1") {
    return { country: null, required: true };
  }
  return { country, required: CONSENT_COUNTRIES.has(country) };
}

let regionLookup: Promise<ConsentRegion> | undefined;

export function getConsentRegion(): Promise<ConsentRegion> {
  return regionLookup ??= lookupRegion();
}

async function lookupRegion(): Promise<ConsentRegion> {
  try {
    const response = await fetch("/cdn-cgi/trace", { signal: AbortSignal.timeout(2000) });
    if (!response.ok) return { country: null, required: true };
    return parseConsentRegion(await response.text(), window.location.hostname);
  } catch {
    return { country: null, required: true };
  }
}